import { Box, Typography, Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useSelector } from "react-redux";

import ReachLogo from "../../assets/Logos/reach_logo_text.png";
import IllustrationRight from "../../assets/Ideas/Ideas2.png";
import IllustrationLeft from "../../assets/Ideas/Ideas1.png";
import { ILoggedUser } from "../../store/actions";
import { Position } from "../Login/LoginUtils";
import "./Ideas.scss";

export default function Ideas() {
	const loggedUser: ILoggedUser = useSelector(
		(state: any) => state.loggedUser.loggedUser,
	);
	const navigator = useNavigate();

	return (
		<Box className="ideas">
			<Box className="ideas__grain" />

			<Box className="ideas__left">
				<img
					className="ideas__left__background"
					src={IllustrationLeft}
					alt=""
				/>

				<img
					className="ideas__left__logo"
					alt=""
					src={ReachLogo}
				/>

				<Typography className="ideas__left__title">CHRISTUS MUGUERZA</Typography>
			</Box>

			<Box className="ideas__right">
				<img
					className="ideas__right__background"
					src={IllustrationRight}
					alt=""
				/>

				<Stack
					sx={{
						padding: "2rem 3rem",
					}}
				>
					<Button
						className="ideas__right__return"
						onClick={() => navigator("/")}
					>
						<ChevronLeft />
						<Typography>Regresar</Typography>
					</Button>

					<Typography className="ideas__right__text">Tus ideas</Typography>

					<Stack className="ideas__right__buttons">
						<Button onClick={() => navigator("/comparte_idea")}>
							Comparte tu idea
						</Button>
						{loggedUser.position !== Position.COLAB && (
							<Button onClick={() => navigator("/kanban")}>
								Administra ideas
							</Button>
						)}
					</Stack>
				</Stack>
			</Box>
		</Box>
	);
}
